export default __webpack_public_path__ + "static/media/Wol Do.ee738612.jpg";